import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { logout, useAuth } from '@saas-kit/lib';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@saas-kit/ui';

/**
 * Dead-end screen for an authenticated user who belongs to no workspace.
 * Self-serve workspace creation was removed: they wait to be added by a
 * platform admin or to accept an invitation.
 */
export function NoWorkspacePage(): JSX.Element {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const clearSession = useAuth((s) => s.clearSession);

  const onSignOut = async (): Promise<void> => {
    try {
      await logout();
    } finally {
      clearSession();
      navigate('/auth/login', { replace: true });
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-muted/30 px-4">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader>
            <CardTitle>{t('no_workspace.title')}</CardTitle>
            <CardDescription>{t('no_workspace.body')}</CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              type="button"
              variant="secondary"
              onClick={() => void onSignOut()}
            >
              {t('no_workspace.sign_out')}
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
